module.exports = __webpack_public_path__ + "uv-to-canny-1ef34570e7b46227f66874bfbfdda162.webp";